import type { GateUsageCounterContext, GatedFeatureConfigMap } from "@/store/feature-gates/types";
import { GatingPeriod } from "@/store/feature-gates/types";

// The backend  provides the Feature Gate config, so if we can't load that then
// we fall back to a last-ditch default which has not limits as a worst-case scenario.
// Counters read from precomputed observable values in AppStoreFeatureGatesStore
export const GATED_FEATURE_DEFAULTS: GatedFeatureConfigMap = {
  "note.create": {
    period: GatingPeriod.Monthly,
    limits: {
      free: null,
      paid: null,
      warning: null,
    },
    counter: ({ store }: GateUsageCounterContext) => {
      return store.featureGates.noteCreationCount;
    },
  },
  "chat_message.send": {
    period: GatingPeriod.Monthly,
    limits: {
      free: null,
      paid: null,
      warning: null,
    },
    counter: ({ store }: GateUsageCounterContext) => {
      return store.featureGates.chatMessageCount;
    },
  },
};
